import { CustomerSelectionOption } from '@app/customer/models/customer-selection-option.model';

export function groupCustomersByDivision(customers: CustomerSelectionOption[]) {
  const grouped: { [key: string]: any } = {};
  customers.forEach(customer => {
    if (!customer) return;
    const division = customer.divisionNumber;
    const customerNumber = customer.customerNumber;
    if (!grouped[division]) {
      grouped[division] = { divisionNumber: division, customers: [] };
    }
    grouped[division].customers.push(customerNumber);
  });
  return Object.values(grouped);
}
